import { type RootState } from '../../app/store'
import { type useDispatch } from 'react-redux'
import { setEditablePlayer } from 'app/store/slices/player'
import { TPlayer } from './types'

export const mapStateToProps = (state: RootState) => state.playerSlice
export const mapDispatchToProps = (dispatch: ReturnType<typeof useDispatch>) => {
  return {
    setEditablePlayer: (player: TPlayer) => dispatch(setEditablePlayer(player))
  }
}
